<template>
  <v-app class="app-root">
    <app-navbar />
    <v-main class="pa-0">
      <router-view />
    </v-main>
    <app-footer />
  </v-app>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'App',
  components: { AppNavbar, AppFooter },
};
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;
}

.v-application.app-root {
  font-family: 'Inter', 'Roboto', sans-serif !important;
}
</style>
